import { merge } from "lodash-es";
import moment from "moment";

import { ScheduleEntryDto, ScheduleEntryDurationType } from "@/core/api/generated/v1";

import { GenericCalendarEntry } from "../../components/Calendar/Calendar";
import { CalendarHelper } from "../../helpers/calendar";
import { IdHelper } from "../../helpers/id";
import { ApiEnumName, enumService } from "../../services/enum";

export interface GenericCalendarEntryOfScheduleEntryDto extends GenericCalendarEntry<ScheduleEntryDto> {
  data: ScheduleEntryDto;
}

export class ScheduleEntryMapper {
  // #region CalendarEntry

  public static mapScheduleEntryDtoToGenericCalendarEntry(
    source: ScheduleEntryDto,
    dest?: Partial<GenericCalendarEntryOfScheduleEntryDto>,
  ): GenericCalendarEntryOfScheduleEntryDto {
    let start = CalendarHelper.minDate;
    let end = CalendarHelper.minDate;
    if (source.durationType === ScheduleEntryDurationType.Point) {
      start = source.pointAt ? moment(source.pointAt).toDate() : CalendarHelper.minDate;
      end = start;
    } else if (source.durationType === ScheduleEntryDurationType.Range) {
      // handle open-ended range
      start = source.startsAt ? moment(source.startsAt).toDate() : CalendarHelper.minDate;
      end = source.endsAt
        ? moment(source.endsAt).toDate()
        : source.startsAt
          ? moment(source.startsAt).add(10, "years").toDate()
          : CalendarHelper.maxDate;
    }

    return merge(
      {},
      {
        ...dest,
        id: source.id || IdHelper.newTempFeId(),
        title: "", // handled separately
        titleStr: `${enumService.getEnumValueName(ApiEnumName.EntityType, source.sourceEntity?.entity?.entityType)} ${source.sourceEntity?.entity?.nameComputed}`,
        start: start,
        end: end,
        isAllDay: false,
        resource: undefined,
        data: source,
      } satisfies GenericCalendarEntryOfScheduleEntryDto,
      dest || {},
    );
  }

  // #endregion GenericDamage
}
